import { patchState, signalStoreFeature, withMethods, withState } from '@ngrx/signals';
import isEqual from 'lodash-es/isEqual';
import { AdvancedCommerce } from '../../advanced-commerce.namespace';
import { AdvancedCommerceStore } from '../advanced-commerce-store.namespace';
import { withConfig } from './config.feature';

export function withBase() {
    return signalStoreFeature(
        withState<AdvancedCommerceStore.State>({
            data: {},
            element: AdvancedCommerce.Query.Element.search
        }),
        withConfig(),
        withMethods(store => {
            return {
                dataSet(data: AdvancedCommerceStore.Data) {
                    const currentData = store.data();

                    if (!isEqual(currentData, data)) {
                        patchState(store, { data });
                    }
                },
                elementSet(element: AdvancedCommerceStore.Element) {
                    const currentElement = store.element();

                    if (currentElement !== element) {
                        patchState(store, { element });
                    }
                }
            };
        })
    );
}
